import React from 'react';
export const Edit = _ref => {
  let {
    color = 'currentColor',
    size = '24',
    strokeWidth = '2'
  } = _ref;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: strokeWidth,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, React.createElement("polygon", {
    points: "14 2 18 6 7 17 3 17 3 13 14 2"
  }), React.createElement("line", {
    x1: "3",
    y1: "22",
    x2: "21",
    y2: "22"
  }));
};